module.exports = __webpack_public_path__ + "img/panel_c.7a8512cc.png";